module.exports = __webpack_public_path__ + "static/img/39_dance.56aa7e36.jpg";